import React from 'react';
import routes from '../../../controller/Routes';
import { getAdminDetail, isAdminLoggedIn } from '../../../controller/localStroageHandler';
import { Navigate } from 'react-router-dom';
import Dashboard from '../component/Dashboard';
import { Role } from '../../../controller/enum';
const OrganizationPrivateRoutes = ({ children }) => {
  let data = getAdminDetail()
  return (isAdminLoggedIn() && data?.role == Role.organization) ? (
    <Dashboard children={children} />
  ) : (
    <Navigate to={routes.admin.login} />
  );
};

export default OrganizationPrivateRoutes;
